import httpClient from '../../api';
import { pick } from '../../functions';
import { candidateStatuses } from '../../enums';

const CANDIDATE_INTERVIEW_FIELDS = ['id', 'status', 'viewed', 'viewedAt'];

export default () => ({
  namespaced: true,

  state() {
    return {
      data: {},
    };
  },

  mutations: {
    setData(state, payload) {
      state.data = { ...payload };
    },
  },

  actions: {
    async fetch({ commit }, { id }) {
      const { data: { data: interview } } = await httpClient.get(
        `interviews/${id}`,
      );

      commit('setData', interview);
      commit(
        'candidate/updateCandidate',
        { interview: pick(interview, CANDIDATE_INTERVIEW_FIELDS) },
        { root: true },
      );
    },
    async store({ commit }, { candidateId }) {
      const { data: { data: interview } } = await httpClient.post(
        `candidates/${candidateId}/interview`,
      );

      commit('setData', interview);
      commit(
        'candidate/updateCandidate',
        { interview: pick(interview, CANDIDATE_INTERVIEW_FIELDS) },
        { root: true },
      );
    },
    async startPublication({ commit }, { id }) {
      const { data: { data: interview } } = await httpClient.post(`interviews/${id}/publication`);

      commit('setData', interview);
      commit(
        'candidate/updateCandidate',
        { interview: pick(interview, CANDIDATE_INTERVIEW_FIELDS) },
        { root: true },
      );
    },
    async continuePublication({ commit }, { id }) {
      const { data: { data: interview } } = await httpClient.patch(`interviews/${id}/publication`);

      commit('setData', interview);
      commit(
        'candidate/updateCandidate',
        { interview: pick(interview, CANDIDATE_INTERVIEW_FIELDS) },
        { root: true },
      );
    },
    async stopPublication({ commit }, { id }) {
      const { data: { data: interview } } = await httpClient.delete(`interviews/${id}/publication`);

      commit('setData', interview);
      commit(
        'candidate/updateCandidate',
        {
          interview: pick(interview, CANDIDATE_INTERVIEW_FIELDS),
          status: candidateStatuses.INTERVIEWED,
        },
        { root: true },
      );
    },
  },
});
